import { Injectable } from '@angular/core';
import { VehicleEntity } from '@domain/dto/vehicle/vehicle-get.dto';
import { VehicleUsecase } from '@domain/usecases/vehicle/vehicle-usecase';

import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VehicleController {
  constructor(private usecaseService: VehicleUsecase) {}

  get(params: any): Observable<VehicleEntity> {
    return this.usecaseService.get(params);
  }
}
